import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        user: '',
        emofUserTokenSafer: '',
        cookie_user: '',
    },
    mutations: {
        increment(state) {
            // 变更状态
            state.token = ''
            state.user = ''
            state.emofUserTokenSafer = ''
        },
        upUserInfo(state,data){
            state.user = data
        }
    },
    actions: {
        LogOut(context) {
            context.commit('increment')
        },
        upUserInfo(context,data) {
            context.commit('upUserInfo',data)
        },
    },
    modules: {
    }
})
